module.exports = __webpack_public_path__ + "static/media/eye-close.b62f055f.svg";